import styled from 'styled-components';
import { Title } from '../../theme/theme'

const fontTitle = 'Raleway'

const NotFoundText = styled.h1`
    font-size: 30px;
    text-align: center;
    font-weight: '400';
    font-family: ${fontTitle};
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        font-size: 16px;
    }
`;


const SearchTitleResult = styled(Title)`
    font-size: 20px;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
       margin-top: 5px
    }
`

const NotFoundContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
    padding: 10vh;
    margin-top: 10vh;
`

export {NotFoundText, NotFoundContainer, SearchTitleResult}